module.exports = __webpack_public_path__ + "static/media/homepage-hero2.3cc3e864.png";